import * as FUEL_ELIGIBILITY from '../../constants/fuel-availability-codes';

/**
 * Transforms the object in the shape of the props given to the
 * `<SettingsFilters />` component into a shapre that it requires for its own
 * internal state.
 *
 * @param {SettingsFilters.propTypes} props
 * @returns {SettingsFiltersState}
 */
export function mapPropsToState(props) {
  return {
    fuelsRequired: {
      electricity: props.requiresElectricity,
      gas: props.requiresGas,
    },
    hasSolarPanels: props.hasSolarPanels,
    renewableEnergy: props.renewableEnergy,
    isCustomerMoving: props.isCustomerMoving,
    postcode: props.postcode,
    isBusiness: props.isBusiness,
  };
}

/**
 *
 * @param {string} eligibilityStatus
 * @returns {boolean}
 */
export function isFuelEligibleForPurchase(eligibilityStatus) {
  return (
    eligibilityStatus === FUEL_ELIGIBILITY.FULL ||
    eligibilityStatus === FUEL_ELIGIBILITY.PARTIAL ||
    eligibilityStatus === FUEL_ELIGIBILITY.UNKNOWN
  );
}
